<template>
  <div>
    <b-modal v-model="showPopUpEmail" has-modal-card class="modal">
      <pop-up-mail
        :mail="mail"
        :contacts="contacts"
        :title="titlePopUp"
        :error="errorEmail"
        :editionsAInclure="editionsAInclure"
        @sendEmail="envoieMail()">
      </pop-up-mail>
    </b-modal>
    <button class="button"
            :class="{'button-access-no-permission': !checkPermissions(perm)}"
            @click="checkPermissions(perm) ? openPopUpEmail() : showPopUp()">
      <b-icon icon="email-plus" type="is-default"></b-icon>
    </button>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import generationMail from '@/services/dcf/generationMail';
import messageErreur from '@/services/general/messageErreur';
import messageSucces from '@/services/general/messageSucces';
import validationEnvoieMail from '@/services/general/validation/validationEnvoieMail';
import getInfoContacts from '@/services/general/mail/getInfoContactsMail';
import emailAsync from '@/api/mail';
import popUpMail from '@/components/general/p_mail';

const permissions = createNamespacedHelpers('permissions');
const Societe = createNamespacedHelpers('societe');
const User = createNamespacedHelpers('user');

export default {
  props: {
    perm: {
      type: Object,
      required: true,
    },
    dcfDetail: {
      type: Object,
      required: true,
    },
    editionsAInclure: {
      type: Array,
      required: true,
    },
    mailSetUp: {
      type: Object,
      required: false,
    },
    titlePopUp: {
      type: String,
      required: true,
    },
  },
  components: {
    popUpMail,
  },
  data() {
    return {
      showPopUpEmail: false,
      errorEmail: {
        messages: [],
        haveError: false,
      },
      mail: null,
      contacts: [],
    };
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societe.mapGetters({
      societesInformations: 'societesInformations',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    dcfSocieteId() {
      return this.dcfDetail.generalInfos.societeId;
    },
    dcfId() {
      return this.dcfDetail.id;
    },
  },
  methods: {
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    async openPopUpEmail() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.errorEmail.messages = [];
        this.errorEmail.haveError = false;
        const tiersImplique = [
          ...this.dcfDetail.payeurs,
          ...this.dcfDetail.intervenants,
        ];
        if (this.dcfDetail.destinataire) {
          tiersImplique.push(this.dcfDetail.destinataire);
        }
        this.contacts = await getInfoContacts(tiersImplique, this.mailSetUp.contactDCFTitle);
        this.mail = await generationMail(
          this.dcfDetail.intervenants,
          this.dcfDetail.destinataire?.tiersId,
          this.user,
        );
        if (this.mailSetUp?.parametreAgenceCorpMail) {
          this.societesInformations.forEach((societe) => {
            societe.agences.forEach((agence) => {
              if (agence.id === this.dcfDetail.generalInfos.agenceId) {
                this.mail.corps = agence[this.mailSetUp.parametreAgenceCorpMail] ?? '';
              }
            });
          });
        }
        this.mail.objet = this.mailSetUp?.objet ?? '';
        this.showPopUpEmail = true;
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    async envoieMail() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.errorEmail.messages = [];
        this.errorEmail.haveError = false;
        await this.envoieMailFacture(
          this.mail,
          this.editionsAInclure[0],
        );
        messageSucces(this.$i18n.t('mail.success.envoie'));
        this.showPopUpEmail = false;
        loadingComponent.close();
      } catch (e) {
        if (e.response.data.error) {
          validationEnvoieMail(e.response, this.errorEmail.messages);
          this.errorEmail.haveError = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    async envoieMailFacture(mail, edition) {
      const params = {
        mettreEdition: edition.value,
        typeDonnee: edition.type,
        elementId: this.dcfId,
        societeId: this.dcfSocieteId,
      };
      const data = new FormData();
      data.append('mailRequest', JSON.stringify(mail));
      if (mail.piecesJointes) {
        mail.piecesJointes.forEach((file) => {
          data.append(file.name, file, file.name);
        });
      }
      await emailAsync(params, data);
    },
  },
};
</script>

<style>

</style>
